import { SearchResultsList, SearchResultsMap } from '../screens';

const searchResultsRoutes = [
  {
    path: 'list',
    component: SearchResultsList,
    title: 'List',
  },
  {
    path: 'map',
    component: SearchResultsMap,
    title: 'Map',
  },
];

export default searchResultsRoutes;
